import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import { Outlet } from 'react-router-dom';
import Footer from '../components/Footer/Footer';
import { FaArrowUpLong } from "react-icons/fa6";

const Main = () => {
    const top = () => {
        window.scrollTo(0, 0);
    }
    return (
        <div>
            <div className='w-full sticky top-0 z-20'>
                <Navbar></Navbar>
            </div>
            <div className=" text-white bg-indigo-950">
                <Outlet></Outlet>
            </div>

            <div className='bg-indigo-950 text-teal-300 flex justify-center py-32 font-bold text-xl'>
                <button onClick={top} className=' border rounded-full p-4 shadow-2xl w-14 h-14 flex justify-center items-center' title='Go to top'>
                    <FaArrowUpLong className='animate-bounce'></FaArrowUpLong>
                </button>
            </div>
            <Footer></Footer>
        </div>
    );
};

export default Main;